<template>
    <v-row class="mx-3">
      <v-col cols="12" class="py-0">
        <SimpleCheckboxField
            v-if="this.edit"
            id="no-career"
            :value="noCareer"
            :name="label('noCareer')"
            :required="value.length === 0"
            :required-error-message="error('needToBeAddCareer')"
            @change="onInputNoCareer"
        />
        <v-simple-table >
          <tbody>
            <tr v-for="(career, index) in value" :key="index" >
              <td v-show="!isSelected(index)" @click="select(index)" class="jobHistory">
                <v-row>
                  <span class="companyName">{{ career.company }}</span>
                  <span class="periodo">{{ label("periodo",[career.startDate, career.endDate]) }}</span>
                </v-row>
                <v-row>
                  <span class="position">{{ career.position }}</span>
                </v-row>
                <v-row>
                  <span class="parttime">{{ candidateEmploymentStatus(career.employmentStatus) }}</span>
                </v-row>
                <v-row>
                  <span class="jobDetail">{{ career.jobDetail }}</span>
                </v-row>
              </td>
              <CareerHistoryForm
                            v-if="isSelected(index)"
                            :value="career"
                            :index="index"
                            @update="updateCareerHistory"
                            @cancelUpdate="cancelUpdate"
                            @delete="deleteCareerHistory"
              />
            </tr>
          </tbody>
        </v-simple-table>
        <CareerHistoryForm
                        v-if="this.edit && selected === null"
                        @add="addCareerHistory"
        />
      </v-col>
    </v-row>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import CareerHistoryForm from "../organisms/CareerHistoryForm"
  import SimpleCheckboxField from "@/components/atoms/SimpleCheckboxField";
  import { mapGetters } from "vuex";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "CareerHistoryList",
    props: {
      "value": {
        type: Array,
        default: () => ([])
      },
      "edit": Boolean,
      noCareer: Boolean,
    },
    data: function() {
      return {
        selected: null,
      };
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      isEditing () {
        if ( this.edit ) {
          return true;
        }
        return false;
      },
      candidateEmploymentStatus () {
        return (value) => {
          return this.constsToText(value, this.consts.candidateEmploymentStatus)
        }
      }
    },
    methods: {
      select (index) {
        this.selected = index
      },
      isSelected (index) {
        if ((index === this.selected) && this.edit ) {
          return true;
        }
        return false;
      },
      onInputNoCareer (value) {
        this.$emit("inputNoCareer", value);
      },
      addCareerHistory (careerHistory) {
        this.value.push(careerHistory)
        this.$emit("inputNoCareer", false);
      },
      updateCareerHistory (careerHistory, index) {
        this.selected = null
        this.value.splice(index, 1, careerHistory)
      },
      cancelUpdate () {
        this.selected = null
      },
      deleteCareerHistory (index) {
        this.selected = null
        this.value.splice(index, 1)
      },
    },
    components: {
      SimpleCheckboxField,
      CareerHistoryForm
    }
  }
</script>

<style scoped lang="sass">
  .jobHistory
    padding: 12px 30px
  .companyName
    font-size: 16px
  .position
    white-space: pre-wrap
  .periodo
    font-size: 16px
    margin-left: 10px
  .parttime
    font-size: 12px
  .jobDetail
    font-size: 14px
    margin-top: 10px
    white-space: pre-wrap
</style>
